(function() {
  // лог для быстрой диагностики
  function log(){ try{ console.debug('[HV UTM]', ...arguments); }catch(e){} }

  // 1) базовые утилиты cookie
  var DAYS = 90;
  function setCookie(name, value, days) {
    try {
      var d = new Date(); d.setTime(d.getTime() + days*864e5);
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value)
        + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax' + secure;
    } catch(e){ log('setCookie error', e); }
  }
  function getCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}\]\\^])/g,'\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function qs(k){ try{ return new URLSearchParams(location.search).get(k) || ''; }catch(e){ return ''; } }
  function save(name,val){ if(val) { setCookie(name,val,DAYS); log('cookie set', name, val); } }

  // 2) собрать текущие метки
  var now = {
    utm_source:   qs('utm_source'),
    utm_medium:   qs('utm_medium'),
    utm_campaign: qs('utm_campaign'),
    utm_content:  qs('utm_content'),
    utm_term:     qs('utm_term'),
    gclid:        qs('gclid') || qs('wbraid') || qs('gbraid'),
    fbclid:       qs('fbclid')
  };
  var hasUTM = Object.keys(now).some(function(k){ return !!now[k]; });

  // 3) landing/referrer + first/last touch
  if (!getCookie('hv_landing_page')) save('hv_landing_page', location.href.split('#')[0]);
  if (!getCookie('hv_referrer'))     save('hv_referrer', document.referrer ? (new URL(document.referrer)).hostname : 'direct');

  if (hasUTM){
    Object.keys(now).forEach(function(k){ if(now[k]) save('hv_'+k, now[k]); });
    if (!getCookie('hv_first_touch_ts')) save('hv_first_touch_ts', String(Date.now()));
    save('hv_last_touch_ts', String(Date.now()));
  }
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid']
    .forEach(function(k){ if (!getCookie('hv_ft_'+k) && getCookie('hv_'+k)) save('hv_ft_'+k, getCookie('hv_'+k)); });

  // 4) отправить в cart attributes (order-level)
  function pushCartAttributes(){
    var attrs = {
      utm_source: getCookie('hv_utm_source'),
      utm_medium: getCookie('hv_utm_medium'),
      utm_campaign: getCookie('hv_utm_campaign'),
      utm_content: getCookie('hv_utm_content'),
      utm_term: getCookie('hv_utm_term'),
      gclid: getCookie('hv_gclid'),
      fbclid: getCookie('hv_fbclid'),
      referrer: getCookie('hv_referrer'),
      landing_page: getCookie('hv_landing_page'),
      ft_utm_source: getCookie('hv_ft_utm_source'),
      ft_utm_medium: getCookie('hv_ft_utm_medium'),
      ft_utm_campaign: getCookie('hv_ft_utm_campaign'),
      ft_utm_content: getCookie('hv_ft_utm_content'),
      ft_utm_term: getCookie('hv_ft_utm_term')
    };
    Object.keys(attrs).forEach(function(k){ if(!attrs[k]) delete attrs[k]; });
    if (!Object.keys(attrs).length) return;
    fetch('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      credentials:'same-origin', body: JSON.stringify({ attributes: attrs })
    }).then(function(){ log('cart attributes pushed', attrs); })
      .catch(function(e){ log('cart attributes error', e); });
  }
  // вызываем сразу
  pushCartAttributes();

  // 5) скрытые inputs в add-to-cart (включая selling plan)
  function inject(form){
    var map = {
      'properties[utm_source]': getCookie('hv_utm_source'),
      'properties[utm_medium]': getCookie('hv_utm_medium'),
      'properties[utm_campaign]': getCookie('hv_utm_campaign'),
      'properties[utm_content]': getCookie('hv_utm_content'),
      'properties[utm_term]': getCookie('hv_utm_term'),
      'properties[gclid]': getCookie('hv_gclid'),
      'properties[fbclid]': getCookie('hv_fbclid'),
      'properties[referrer]': getCookie('hv_referrer'),
      'properties[landing_page]': getCookie('hv_landing_page')
    };
    Object.keys(map).forEach(function(name){
      var val = map[name]; if(!val) return;
      if (form.querySelector('input[name="'+name+'"]')) return;
      var i = document.createElement('input'); i.type='hidden'; i.name=name; i.value=val; form.appendChild(i);
    });
  }
  function hook(){ document.querySelectorAll('form[action*="/cart/add"]').forEach(inject); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();

  log('init', {hasUTM: hasUTM, now: now});
})();
